<template>
    <transition name="toast-fade">
        <span class="totem-toast" v-if="showToast" :style="cssVars" v-html="text"></span>
    </transition>
</template>

<script>
    export default {
        name: 'totem-toast',
        props: {
            top: {
                type: Number,
                default: 50
            },
            minWidth: {
                type: Number
            }
        },
        methods: {
            show (text) {
                this.showToast = true
                this.text = text
                setTimeout(() => this.showToast = false, this.timeout)
            }
        },
        data () {
            return {
                text: null,
                showToast: false
            }
        },
        computed: {
            cssVars() {
                return {
                    '--top': this.top + '%',
                    '--min-width': this.minWidth + 'px'
                }
            },
            timeout () {
                return this.text.length * 150
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-toast {
        font-family: PlusJakartaSans-Medium, sans-serif;
        position: fixed;
        margin: 10px;
        background-color: $green;
        color: $tuatara;
        border-radius: 20px;
        padding: 50px 30px 20px;
        transition: all 0.5s;
        font-size: 1.6rem;
        line-height: 150%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        transform: translateX(-50%);
        left: 50%;
        top: var(--top);
        min-width: var(--min-width);
        z-index: 999;

        &:before {
            content: '\e965';
            font-family: 'icomoon';
            font-size: 3rem;
            position: absolute;
            top: 15px;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .toast-fade-enter-active, .toast-fade-leave-active {
        transition: opacity .5s;
    }

    .toast-fade-enter, .toast-fade-leave-to {
        opacity: 0;
    }
</style>
